/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import api from "../../lib/api";
import Errors from "../Errors";
import DynamicTableData from "./DynamicTableData";
import { Button } from "@blueprintjs/core";

function DynamicTable(props) {
  const {
    endpoint,
    fields: fieldsExtra,
    rowRenderer,
    toolbarRenderer: ToolbarRenderer,
  } = props;

  const [page, setPage] = useState(null);
  const [sort, setSort] = useState(null);
  const [filter, setFilter] = useState(null);
  const [meta, setMeta] = useState({ page: {}, sort: {}, fields: {} });
  const [status, setStatus] = useState("init");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);

  const compileParams = (paramPage) => ({
    page: paramPage
      ? {
          offset: paramPage.offset || undefined,
          limit: paramPage.limit || undefined,
        }
      : undefined,
    sort: sort || undefined,
    filter: filter || undefined,
  });

  const getData = async (paramPage, cancelToken) => {
    const { data: returnedData } = await api.get(endpoint, {
      params: compileParams(paramPage),
      cancelToken,
    });
    return returnedData;
  };

  const onRefreshPage = async () => {
    if (status !== "error") {
      setStatus("fetching");
    }

    try {
      const returnedData = await getData(page);
      if (returnedData.meta && returnedData.meta.fields) {
        for (const [k, v] of Object.entries(fieldsExtra || {})) {
          returnedData.meta.fields[k] = Object.assign(
            returnedData.meta.fields[k] || {},
            v
          );
        }
      }
      setMeta(returnedData.meta);
      if (returnedData.meta.page.offset === 0) {
        setData(returnedData.data);
      } else {
        setData([...data, ...returnedData.data]);
      }
      setStatus("ready");
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);

      setMeta({ page: {}, sort: {}, fields: {} });
      setData([]);
      setStatus("error");
      setErrors(err.response && err.response.data && err.response.data.errors);
    }
  };

  // Get list of fields from server.
  useEffect(() => {
    onRefreshPage();
  }, [page]);

  useEffect(() => {
    console.log("SORT!");
    setPage((oldPage) => ({ ...(oldPage || {}), offset: 0 }));
  }, [sort, filter]);

  return (
    <div className={`DynamicTable`}>
      {status === "error" && <Errors.Callout errors={errors} />}

      {status !== "error" && (
        <>
          {ToolbarRenderer && (
            <ToolbarRenderer
              fields={meta.fields}
              filter={filter}
              setFilter={setFilter}
            />
          )}
          <DynamicTableData
            isLoading={status === "init" || status === "fetching"}
            fields={meta.fields}
            sort={meta.sort}
            setSort={setSort}
            data={data}
            rowRenderer={rowRenderer}
          />
        </>
      )}
      {status === "ready" && (
        <p
          className="bp3-small"
          style={{
            padding: "1em",
          }}
        >{`Showing ${data.length} of ${meta.page.itemsCount}`}</p>
      )}
      {status === "ready" && data.length < meta.page.itemsCount && (
        <Button
          className="bp3-button bp3-intent-success print-hide"
          onClick={() => {
            setPage({
              offset: data.length,
              limit: data.length * 2,
            });
          }}
        >{`Show more`}</Button>
      )}
    </div>
  );
}

DynamicTable.propTypes = {
  // className: PropTypes.string.isRequired,
  endpoint: PropTypes.string.isRequired,
  // fields: PropTypes.objectOf(PropTypes.shape).isRequired,
  // lastUpdatedAt: PropTypes.number.isRequired,
  // enableExportData: PropTypes.bool,
  // FilterComponent: PropTypes.elementType,
  // ActionsComponent: PropTypes.elementType,
  // onRowAction: PropTypes.func,
};

DynamicTable.defaultProps = {
  // enableExportData: false,
  // FilterComponent: null,
  // ActionsComponent: null,
  // onRowAction: null,
};

export default DynamicTable;
